import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 text-center border-t border-slate-800/50 bg-[#0a0e1a]" data-id="element-42">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-43">
          <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-cyan-400 text-sm underline underline-offset-2 transition-colors" data-id="element-44">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline text-slate-700" data-id="element-45">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-cyan-400 text-sm underline underline-offset-2 transition-colors" data-id="element-46">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-slate-500 text-sm" data-id="element-47">
          © {new Date().getFullYear()} El Interruptor de Energía. Todos los
          derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-48">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-49">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-[#111827] border border-slate-700/50 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-50">
              <div className="sticky top-0 bg-[#111827] border-b border-slate-700/50 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-51">
                <h3 className="text-xl font-bold text-white" data-id="element-52">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-700/50 transition-colors text-slate-400 hover:text-white" data-id="element-53">
                  <X className="w-5 h-5" data-id="element-54" />
                </button>
              </div>

              <div className="px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-55">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-56" /> : <TermsContent data-id="element-57" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <h4 className="text-lg font-semibold text-white" data-id="element-58">
        1. Información que recopilamos
      </h4>
      <p data-id="element-59">
        Recopilamos únicamente la información necesaria para procesar tu compra:
        nombre, dirección de correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito directamente; estos datos son
        procesados de forma segura por nuestro proveedor de pagos.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-60">
        2. Uso de la información
      </h4>
      <p data-id="element-61">
        Tu información se utiliza exclusivamente para: entregar el producto
        digital adquirido, enviar actualizaciones relacionadas con tu compra y
        brindarte soporte si lo necesitas. No vendemos, alquilamos ni
        compartimos tu información personal con terceros con fines comerciales.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-62">
        3. Protección de datos
      </h4>
      <p data-id="element-63">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-64">4. Cookies</h4>
      <p data-id="element-65">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario y analizar el tráfico del sitio. Puedes configurar tu navegador
        para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-66">5. Tus derechos</h4>
      <p data-id="element-67">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los canales disponibles.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <h4 className="text-lg font-semibold text-white" data-id="element-68">1. Producto digital</h4>
      <p data-id="element-69">
        "El Interruptor de Energía" es un producto digital (ebook) en formato
        descargable. Al completar tu compra, recibirás acceso inmediato al
        contenido. Este producto es para uso personal y no puede ser
        redistribuido, revendido ni compartido sin autorización.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-70">
        2. Garantía de satisfacción
      </h4>
      <p data-id="element-71">
        Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los
        primeros 7 días posteriores a tu compra consideras que el protocolo no
        te ha sido útil, puedes solicitar un reembolso completo de tu dinero sin
        preguntas.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-72">
        3. Descargo de responsabilidad
      </h4>
      <p data-id="element-73">
        El contenido de este ebook es informativo y educativo. No sustituye el
        consejo médico profesional. Siempre consulta con un profesional de la
        salud antes de realizar cambios significativos en tu estilo de vida,
        especialmente si tienes condiciones médicas preexistentes o estás bajo
        tratamiento.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-74">4. Resultados</h4>
      <p data-id="element-75">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos, ya que estos dependen de factores individuales
        como la adherencia al protocolo, el estado de salud previo y otros
        hábitos de vida.
      </p>

      <h4 className="text-lg font-semibold text-white" data-id="element-76">
        5. Propiedad intelectual
      </h4>
      <p data-id="element-77">
        Todo el contenido del ebook, incluyendo textos, gráficos y metodologías,
        está protegido por derechos de autor. Queda prohibida su reproducción
        total o parcial sin consentimiento previo por escrito.
      </p>
    </>;
}